// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-4c6ad91c]{box-sizing:border-box;font-family:Arial,sans-serif;margin:0;padding:0}.table-container[data-v-4c6ad91c]{margin:20px;max-width:100%;overflow-x:auto}table[data-v-4c6ad91c]{border-collapse:collapse;width:100%}td[data-v-4c6ad91c],th[data-v-4c6ad91c]{border:1px solid #ddd;padding:8px;text-align:left}th[data-v-4c6ad91c]{background-color:#f2f2f2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
